import { render } from "./StyleguideTableEasy.pug?vue&type=template&id=af58e9ae&lang=pug"
import script from "./StyleguideTableEasy.js?vue&type=script&lang=js"
export * from "./StyleguideTableEasy.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__